export default function () {

    let searchForm = document.getElementsByClassName('js-city-search')[0];

    if(searchForm) {
        let cityCallback = searchForm.getAttribute('data-callback');
        let dataProfile = searchForm.getAttribute('data-profile');
        let options = {
            dataType: 'json',
            serviceUrl: searchForm.getAttribute('data-autocomplete-url'),
            appendTo: $('.js-city-search'),
            minChars: 2,
            deferRequestBy: 100,
            formatResult: function (suggestion, currentValue) {
                let regex = new RegExp(currentValue, 'gi');
                let result = suggestion.value.replace(regex, '<strong>' + currentValue + '</strong>');
                return `<div class="autocomplete-suggestion__link"><span class="autocomplete-suggestion__name">${result}</span></div>`;
            },
            showNoSuggestionNotice: true,
            onSearchStart: function () {
                searchForm.classList.add('is-loading');
            },
            noSuggestionNotice: 'По запросу нет совпадений',
            onSearchComplete: function () {
                searchForm.classList.add('show-results');
                setTimeout(function () {
                    searchForm.classList.remove('is-loading');
                }, 300);
            },
            onSelect: function (suggestion) {
                if(cityCallback) {
                    window[cityCallback](dataProfile, suggestion.data.id, suggestion.value);
                }
                else{
                    window.setCookie('locationId', suggestion.data.id, {expires : 7*3600*24, path: '/'});
                    window.setCookie('locationName', suggestion.value, {expires : 7*3600*24, path: '/'});
                    window.setCookie('citySelected', '1', {expires : 7*3600*24, path: '/'});
                    window.location.reload();

                }
            },
            onHide: function () {
                searchForm.classList.remove('show-results');
            }
        };

        let search = $('.js-city-search-input').autocomplete(options)
    }

}
